<div class="razao">
    <div class="razao-barra">
        @for (seg of segmentos(); track seg.label) {
            <span class="razao-segmento" [style.width.%]="seg.percentual" [style.background]="seg.cor" [attr.title]="seg.label + ': ' + seg.percentual + '%'"></span>
        }
    </div>
    <ul class="razao-legenda">
        @for (seg of segmentos(); track seg.label) {
            <li class="razao-item">
                <span class="razao-dot" [style.background]="seg.cor"></span>
                <span class="razao-label" [title]="seg.label">{{ seg.label }}</span>
                <span class="razao-valor">{{ seg.total | number }}</span>
                <span class="razao-pct">{{ seg.percentual }}%</span>
            </li>
        }
    </ul>
</div>
